import styled from 'styled-components';

export const StyledCardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
`;

export const DealerName = styled.span`
    font-weight: 600;
`;
